<template>
    <div>
        <div class="d-flex justify-space-between align-center" v-if="!$store.state.baseLoading">
            <v-btn icon="mdi-arrow-right" variant="text" @click="$store.commit('setActivePage',backPage)"></v-btn>
            <h3>{{ $store.state.info.direct_title }}</h3>

            <div class="d-flex align-center gap-1">
                <!-- toggle رنگ -->
                <v-menu location="bottom end" :close-on-content-click="true">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" :icon="themeModeIcon" variant="text" size="small" />
                    </template>
                    <v-list density="compact" min-width="140" rounded="lg">
                        <v-list-item
                            v-for="item in themeModes"
                            :key="item.value"
                            :prepend-icon="item.icon"
                            :title="item.label"
                            :active="themeMode === item.value"
                            @click="$store.commit('setThemeMode', item.value)"
                        />
                    </v-list>
                </v-menu>

                <v-btn v-if="$store.getters.getAuthToken == ''" 
                        :disabled="$store.state.baseLoading"
                        variant="outlined" 
                        @click="$store.commit('setLoginDialogStatus', true)">
                    {{ $t('booking.login_button') }}
                </v-btn>
                
                <v-menu v-else>
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" icon="mdi-account" variant="text"></v-btn>
                    </template>
                    <v-list class="text-center">
                        <v-list-item>
                            {{ $t('booking.welcome_message', { mobile: $store.state.mobile }) }}
                        </v-list-item>
                        <v-list-item @click="$store.commit('setActivePage', 'orders_history');">
                            لیست رزروها
                        </v-list-item>
                        <v-list-item @click="$store.state.showProfileDialogStatus=true">
                            پروفایل
                        </v-list-item>
                        <v-list-item @click="$store.dispatch('logout')" class="text-red">
                            {{ $t('booking.logout_button') }}
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </div>
        <v-progress-linear v-else indeterminate color="primary" class="my-6"></v-progress-linear>
    </div>
</template>

<script>
export default {
    props: {
        backPage: {
            type: String,
            default: "splash",
            required: true
        }
    },
    data: () => ({
        themeModes: [
            { value: 'default', label: 'پیش‌فرض', icon: 'mdi-palette'      },
            { value: 'light',   label: 'روشن',    icon: 'mdi-weather-sunny' },
            { value: 'dark',    label: 'تاریک',   icon: 'mdi-weather-night' },
        ],
    }),
    computed: {
        themeMode()     { return this.$store.state.themeMode; },
        themeModeIcon() {
            return {
                default: 'mdi-palette',
                light:   'mdi-weather-sunny',
                dark:    'mdi-weather-night',
            }[this.themeMode] ?? 'mdi-palette';
        },
    },
};
</script>
